import React from 'react';
import ReactDOM from 'react-dom';
import './styles/bootstrap.css';
// import './styles/fontawesome/css/all.min.css'
import './styles/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import CacheBuster from 'react-cache-buster';
import buildMeta from './build-meta.json';
// Configurar interceptores de Axios globalmente
import './common/services/api.interceptor';


// Usa la version generada en build para compararla contra public/meta.json.
const currentVersion = buildMeta.version;
const isProduction = process.env.NODE_ENV === 'production';
// const metaFileDirectory = process.env.PUBLIC_URL || '/';

ReactDOM.render(
    <CacheBuster
        currentVersion={currentVersion}
        isEnabled={isProduction} // Solo en producción
    // metaFileDirectory={metaFileDirectory}
    >
        <App />
    </CacheBuster>,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
